import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 프로필 페이지는 이제 구독 페이지로 통합되었으므로 리다이렉트
    navigate('/subscription', { replace: true });
  }, [navigate]);

  return null;
};

export default Profile; 